import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const CHILD_APP_ORIGIN =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://appointmentsystem-26144.web.app";

const ChildAppFrame = () => {
  const iframeRef = useRef(null);
  const location = useLocation();

  // ✅ preserve path and query string (like /booking-doc-list?search=Cardiology)
  const childUrl = `${CHILD_APP_ORIGIN}${location.pathname}${location.search}`;

  useEffect(() => {
    const token = localStorage.getItem("token") || null;

    const sendToken = () => {
      const iframe = iframeRef.current;
      if (iframe?.contentWindow) {
        console.log("[PARENT → CHILD] Sending message:", {
          type: "SET_TOKEN",
          token,
          apiBaseUrl:
            process.env.NODE_ENV === "development"
              ? "https://api.florenceht.com"
              : "https://api.florenceht.com",
        });

        iframe.contentWindow.postMessage(
          {
            type: "SET_TOKEN",
            token,
            apiBaseUrl:
              process.env.NODE_ENV === "development"
                ? "https://api.florenceht.com"
                : "https://api.florenceht.com",
          },
          CHILD_APP_ORIGIN
        );
      }
    };

    const iframe = iframeRef.current;
    if (iframe) iframe.addEventListener("load", sendToken);

    sendToken(); // also send once immediately
    return () => iframe?.removeEventListener("load", sendToken);
  }, [location]);

  return (
    <iframe
      ref={iframeRef}
      src={childUrl} // ✅ now includes the query string!
      style={{ width: "100%", height: "100vh", border: "none" }}
      title="Child Application"
    />
  );
};

export default ChildAppFrame;
